import { createSlice } from '@reduxjs/toolkit';

const userRegionInfoCookie = PULSE.core.localStorage.getStorage(
    'userRegionInfo',
    true
);
const cookieObject = userRegionInfoCookie
    ? JSON.parse(userRegionInfoCookie)
    : {};

const initialState = {
    timezone: userRegionInfoCookie
        ? cookieObject.timezone
        : moment.tz.guess(true),
    regionName: userRegionInfoCookie ? cookieObject.name : '',
    id: userRegionInfoCookie ? cookieObject.id : '',
    location: userRegionInfoCookie ? cookieObject.timezone.split('/')[0] : '',
    region: userRegionInfoCookie ? cookieObject.timezone.split('/')[1] : ''
};

const selectedRegion = createSlice({
    name: 'selectedRegion',
    initialState,
    reducers: {
        setRegion: (state, action) => {
            state.timezone = action.payload.timezone;
            state.regionName = action.payload.name;
            state.id = action.payload.id;
            state.location = action.payload.location;
            state.region = action.payload.region;
        }
    }
});

if (PULSE.app.redux) {
    PULSE.app.redux.reducers.selectedRegion = {
        root: selectedRegion.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        selectedRegion: selectedRegion.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            selectedRegion: selectedRegion.actions
        },
        reducers: {
            root: {
                selectedRegion: selectedRegion.reducer
            }
        }
    };
}
